<template>
  <div class="contant">
    <div class="footer">
      <div class="list" v-for="(item,index) in list" :key="index">
        <span class="title" @click="goCate(index,item.id)">{{item.title}}</span>
        <div class="sub_title">
          <span v-for="(item,sindex) in item.child" :key="sindex" @click="goSubCate(index,item.id)">{{item.name}}</span>
        </div>
      </div>
    </div>
    <div class="line"></div>
    <div class="other_info">
      <div class="address" @click="addressClick">
        <img src="@/assets/icon_local.png">
        <span>{{base.address}}</span>
      </div>
      <div class="phone" @click="phoneClick">
        <img src="@/assets/icon_phone.png">
        <span>{{base.tel}}</span>
      </div>
      <div class="mail" @click="emailClick">
        <img src="@/assets/icon_mail.png">
        <span>{{base.email}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: "Header",
  data() {
    return {
      list: []
    };
  },
  computed: {
    ...mapGetters(['base'])
  },
  watch: {
    base: {
      handler(newVal) {
        if(newVal.category&&newVal.category.length>0){
          this.list = [
            ...newVal.category.map(item => ({
              title: item.title,
              id: item.id,
              path: `/cellsline/${item.id}`,
              child: item.child.map(childItem => {
                return {
                  name: childItem.title,
                  id: childItem.id,
                  path: `/productinfo/${childItem.id}`
                }
              })
            }))
          ]
        }
      },
      immediate: true
    }
  },
  mounted() {},
  created() {},
  methods: {
    emailClick(){
      window.open(`mailto:${this.base.email}`)
    },
    goCate(index, id) {
      this.$router.push({ path: `/cellsline/${id}` })
    },
    goSubCate(index, id) {
      this.$router.push({ path: `/cellslineinfo/${id}` })
    },
    phoneClick(){
    // 复制
    try{
      navigator.clipboard.writeText(this.base.tel)
     
      this.$message.success('复制成功')
    }catch(err){
      // this.$message.error('复制失败')
      const input = document.createElement('input')
      input.value = this.base.tel
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      
    }
    },
    addressClick(){ 
      
    },
    handleCommand(command) {
      switch (command) {
        case "1":
          this.$router.replace({ path: "/login1" });
          console.log("aaa", command);
          break;
        case "2":
          this.$router.replace({ path: "/login2" });
          console.log("aaa", command);
          break;
        case "3":
          this.$router.replace({ path: "/login3" });
          console.log("aaa", command);
          break;
      }
    }
  }
};
</script>
 <style lang="less" scoped>
.contant {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #1f2023;
  padding: 30px;
  box-sizing: border-box;
}
.footer {
  background: #1f2023;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  flex-wrap: wrap;
  width: 80%;
  border-bottom: 1px solid #828384;
  justify-content: flex-start;
}
.list {
  width: calc(16.666% - 20px);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding-right: 20px;
  padding-bottom: 40px;
  
  .title {
    cursor: pointer;
    font-size: 18px;
    font-weight: 400;
    color: #ffffff;
    line-height: 26px;
    margin-bottom: 10px;
    &:hover{
      color: #3c9c8f;
    }
  }
  .sub_title {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    span {
      color: #828384;
      font-size: 14px;
      margin-top: 5px;
      &:hover{
        color: #3c9c8f;
      }
    }
  }
}
.other_info {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 80%;
  margin-top: 20px;
  .address {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    color: #717578;
    font-size: 14px;
    flex: 1;
  }
  .address img {
    width: 24px;
    height: 24px;
    margin-right: 6px;
  }
  .phone {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    color: #717578;
     flex: 0.5;
    font-size: 14px;
  }
  .phone img {
    width: 24px;
    height: 24px;
    margin-right: 6px;
  }
  .mail {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    color: #717578;
     flex: 0.5;
    font-size: 14px;
  }
  .mail img {
    width: 24px;
    height: 24px;
    margin-right: 6px;
  }
}
</style> 
